import { Button, message, Skeleton, Tooltip } from "antd";
import { fetchFaq } from "api/services/faq/faq.services";
import { FC, useCallback, useEffect, useState } from "react";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";

//!STYLE
import s from "./assets/faq.module.css";

//!IMAGES
import { StatusCode, UserRoles } from "common/enums";
import FadeInUpOnScroll from "components/FadeInUp";
import { badRequest } from "messages";
import { useSelector } from "react-redux";

import arrowRight from "../../../assets/images/app/arrow_right.svg";
import albert from "../../../assets/images/app/faqs/albert.svg";
import arrow from "../../../assets/images/app/faqs/arrow.svg";
import bottomLeftEllipse from "../../../assets/images/app/faqs/bottom-left-ellipse.svg";
import bottomRightEllipse from "../../../assets/images/app/faqs/bottom-right-ellipse.svg";
import midleLeftEllipse from "../../../assets/images/app/faqs/midle-left-ellipse.svg";
import midleRightEllipse from "../../../assets/images/app/faqs/midle-right-ellipse.svg";
import topLeftEllipse from "../../../assets/images/app/faqs/top-left-ellipse.svg";
import trace from "../../../assets/images/app/faqs/top-right-trace.svg";
import organisation from "../../../assets/images/app/iam_organism.svg";
import parent from "../../../assets/images/app/iam_parent.svg";
import student from "../../../assets/images/app/iam_student.svg";
import teacher from "../../../assets/images/app/iam_teacher.svg";
import st from '../../app/common.module.css';

const FAQ: FC = () => {
  //!STATE
  const [loading, setLoading] = useState<boolean>(false);
  const [faqs, setFaqs] = useState<any>([]);
  const [error, setError] = useState<any>(null);
  const { user } = useSelector((s) => s.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [visible, setVisible] = useState(false);
  const [teacherFaqs, setTeacherFaqs] = useState<any>([]);
  const [studentFaqs, setStudentFaqs] = useState<any>([]);
  const [parentFaqs, setParentFaqs] = useState<any>([]);
  const [organisationFaqs, setOrganisationFaqs] = useState<any>([]);
  const [albertFaqs, setAlbertFaqs] = useState<any>([]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [faqData, setFaqData] = useState<any>([]);
  const [categoryData, setCategoryData] = useState<any>([]);
  const [categoryIndex, setCategoryIndex] = useState<number>(0);
  const [seeDetails, setSeeDetails] = useState<boolean>(false);
  const [selectedquestion, setSelectedquestion] = useState<number>(0);

  const [categoryDetailQuestion, setCategoryDetailQuestion] = useState<any>();
  const [categoryDetailAnswer, setCategoryDetailAnswer] = useState<any>();

  const [actorFAQ, setActorFAQ] = useState<any>("Je suis professeur");
  const [categoryFAQ, setCategoryFAQ] = useState<any>("");

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const getFaqs = useCallback(async (type: string) => {
    setLoading(true);
    try {
      const response = await fetchFaq(type);
      if (response.statusCode === StatusCode.OK) {
        const data = transformData(response.data);
        setFaqData(data);
        if (type === "teacher") {
          setTeacherFaqs(data);
        }
        else if (type === "student") {
          setStudentFaqs(data);
        }
        else if (type === "parent") {
          setParentFaqs(data);
        }
        else if (type === "organisme") {
          setOrganisationFaqs(data);
        }
        else if (type === "albert") {
          setAlbertFaqs(data);
        }
      }
    } catch (error) {
      message.error(badRequest.error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  const handleDivClick = (index: any) => {
    setActiveIndex(index);
    if (index === 0) {
      if (teacherFaqs.length === 0) {
        getFaqs("teacher");
      }
      else {
        setFaqData(teacherFaqs);
      }
    }
    else if (index === 1) {
      if (studentFaqs.length === 0) {
        getFaqs("student");
      }
      else {
        setFaqData(studentFaqs);
      }
    }
    else if (index === 2) {
      if (parentFaqs.length === 0) {
        getFaqs("parent");
      }
      else {
        setFaqData(parentFaqs);
      }
    }
    else if (index === 3) {
      if (organisationFaqs.length === 0) {
        getFaqs("organisme");
      }
      else {
        setFaqData(organisationFaqs);
      }
    }
    else if (index === 4) {
      if (albertFaqs.length === 0) {
        getFaqs("albert");
      }
      else {
        setFaqData(albertFaqs);
      }
    }
  };

  const actors = [
    {
      "image": teacher,
      "title": "Je suis professeur"
    },
    {
      "image": student,
      "title": "Je suis étudiant"
    },
    {
      "image": parent,
      "title": "Je suis parent"
    },
    {
      "image": organisation,
      "title": "Je suis un organisme"
    },
    {
      "image": albert,
      "title": "À propos d’Albert"
    },
  ];

  const transformData = (data: any) => {
    return Object.keys(data).map(category => ({
      title: category,
      data: data[category].map((item: { title: any; description: any; }) => ({
        question: item?.title,
        answer: item?.description,
      }))
    }));
  };

  const scrollToResponseBox = () => {
    const element = document.getElementById("ResponseBox");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    getFaqs("teacher");
  }, []);

  useEffect(() => {
    if (faqData) {
      setCategoryData(faqData[0]?.data);
      setCategoryDetailQuestion(faqData[0]?.data?.[0].question);
      setCategoryDetailAnswer(faqData[0]?.data?.[0].answer);
      setCategoryFAQ(faqData[0]?.title);
      setCategoryIndex(0);
    }
  }, [faqData]);

  return (
    <div style={{ marginTop: isMobile ? user && user?.roles?.includes("teacher") && (!userHavingCalendar || userTeachingOrganismClass) ? "130px" : user?.roles?.includes(UserRoles?.STUDENT) ? "20px" : "70px" : "0px" }}>
      {!isMobile && <Breadcrumbs
        isFAQ
        setSeeDetails={setSeeDetails}
        seeDetails={seeDetails}
        actorFAQ={actorFAQ}
        categoryFAQ={categoryFAQ}
        dataFAQ={faqData}
        setCategoryData={setCategoryData}
        setCategoryDetailQuestion={setCategoryDetailQuestion}
        setCategoryDetailAnswer={setCategoryDetailAnswer}
        setCategoryFAQ={setCategoryFAQ}
        setSelectedquestion={setSelectedquestion}
      />}
      <div className={s.faqContainer}>
        {!isMobile && <img src={topLeftEllipse} height={50} className={`${st.floatAnimation}`} style={{ position: "relative", top: "60px", left: "-20px", zIndex: "2" }}></img>}
        {!isMobile && <img src={trace} height={80} style={{ position: "relative", top: "7px", left: "90%", zIndex: "0" }}></img>}
        {!seeDetails ? <div className={s.main}>
          <FadeInUpOnScroll>
            <h1 className={s.title}>Comment pouvons-nous vous aider ?</h1>
          </FadeInUpOnScroll>
          {!isMobile && <img src={arrow} height={70} style={{ position: "relative", top: "-20px", left: "-30px", zIndex: "1" }}></img>}

          <div className={s.actors}>
            {actors.map((actor, index) => (
              <div key={index} className={s.actorBox} onClick={() => { handleDivClick(index); setActorFAQ(actor.title) }} style={{ boxShadow: activeIndex === index ? '0px 4px 15px rgba(0, 0, 0, 0.2)' : 'none', transition: 'box-shadow 0.3s ease' }}>
                <div className={s.imageBox}>
                  <img src={actor.image} alt={actor.title} style={{ width: isMobile ? "30px" : index === 4 ? '35px' : '45px', height: isMobile ? "30px" : index === 4 ? '35px' : '45px' }} />
                </div>
                <div className={s.actorBoxTitle} style={{ color: activeIndex === index ? "#8AB0B1" : "#393E3E" }}>{actor.title}</div>
              </div>
            ))}
          </div>

          {loading ?
            <Skeleton /> : (
              <>
                <div className={s.faqHeaderBox}>
                  {faqData.map((category: any, index: any) => (
                    <div key={index} onClick={() => { setSeeDetails(false); setCategoryData(category?.data); setCategoryFAQ(category?.title); setCategoryIndex(index) }} style={{ borderBottom: categoryIndex === index ? "1px solid #7FB1B2" : "1px solid #f0f0f0" }}>
                      {category?.title ?? "MonAmiAlbert"}
                    </div>
                  ))}
                </div>

                <div style={{ height: "auto", width: "100%", marginTop: "20px" }}>
                  {categoryData.map((faq: any, i: any) => (
                    <div key={i} className={s.categoryQuestion} onClick={() => { setSeeDetails(true); setCategoryDetailQuestion(categoryData?.[i].question); setCategoryDetailAnswer(categoryData?.[i].answer); setSelectedquestion(i) }}>
                      {faq.question || 'Aucune question disponible'}
                      <img src={arrowRight} height={10}></img>
                    </div>
                  ))}
                </div>
              </>
            )
          }
        </div> : <div className={s.main}>
          <div className={s.titleBox}>
            <FadeInUpOnScroll>
              <h1 className={s.title}>Comment pouvons-nous vous aider ?</h1>
            </FadeInUpOnScroll>
            {!isMobile && <Button className={s.backButton} onClick={() => setSeeDetails(false)}>Retour</Button>}
          </div>

          {!isMobile && <img src={arrow} height={70} style={{ position: "relative", top: "-20px", left: "-30px", zIndex: "1" }}></img>}

          <div className={s.faqHeaderBox}>
            {faqData.map((category: any, index: any) => (
              <div key={index} onClick={() => { setSeeDetails(true); setCategoryData(category?.data); setCategoryDetailQuestion(category?.data?.[0].question); setCategoryDetailAnswer(category?.data?.[0].answer); setSelectedquestion(0); setCategoryFAQ(category?.title); setCategoryIndex(index) }} style={{ borderBottom: categoryIndex === index ? "1px solid #7FB1B2" : "1px solid #f0f0f0" }}>
                {category?.title ?? "MonAmiAlbert"}
              </div>
            ))}
          </div>

          <div className={s.detailsBox}>
            <div className={s.leftDetailsBox}>
              {categoryData.map((categoryDetails: any, index: any) => (
                isMobile ? <div className={s.categoryBox} key={index} onClick={() => { setSelectedquestion(index); setCategoryDetailQuestion(categoryDetails?.question); setCategoryDetailAnswer(categoryDetails?.answer); scrollToResponseBox(); }} style={{ background: selectedquestion === index ? "#F1FFF8" : "#FFF", border: selectedquestion === index ? "1px solid #7FB1B2" : "1px solid #E2E2E2", color: selectedquestion === index ? "#8AB0B1" : "#393E3E" }}>
                  <span className={s.categoryText}>{categoryDetails?.question}</span>
                </div> : <Tooltip placement="right" title={categoryDetails?.question}>
                  <div className={s.categoryBox} key={index} onClick={() => { setSelectedquestion(index); setCategoryDetailQuestion(categoryDetails?.question); setCategoryDetailAnswer(categoryDetails?.answer) }} style={{ background: selectedquestion === index ? "#F1FFF8" : "#FFF", border: selectedquestion === index ? "1px solid #7FB1B2" : "1px solid #E2E2E2", color: selectedquestion === index ? "#8AB0B1" : "#393E3E" }}>
                    <span className={s.categoryText}>{categoryDetails?.question}</span>
                  </div>
                </Tooltip>
              ))}
            </div>
            <div className={s.rightDetailsBox} id="ResponseBox">
              <div className={s.categoryBoxTitle}>{categoryDetailQuestion || 'Aucune question disponible'}</div>
              <div className={s.answer} dangerouslySetInnerHTML={{ __html: categoryDetailAnswer || "Aucune réponse disponible" }} />
            </div>
          </div>
        </div>}
        {!isMobile && <img src={midleLeftEllipse} height={150} className={`${st.floatAnimationOne}`} style={{ position: "relative", top: "-650px", left: "-50px", zIndex: "-1" }}></img>}
        {!isMobile && <img src={midleRightEllipse} height={150} className={`${st.floatAnimation}`} style={{ position: "relative", top: "-750px", left: "80%", zIndex: "-1" }}></img>}
        {!isMobile && <img src={bottomLeftEllipse} height={200} className={`${st.floatAnimation}`} style={{ position: "relative", top: "-350px", left: "-370px", zIndex: "-1" }}></img>}
        {!isMobile && <img src={bottomRightEllipse} height={70} className={`${st.floatAnimationOne}`} style={{ position: "relative", top: "-310px", left: "54%", zIndex: "2" }}></img>}
      </div>
    </div>
  );
};

export default FAQ;
